import { PaymentGatewayIntegration } from '../..';

import cvc from '../../components/elements/cvc.vue';
import creditCard from '../../components/elements/creditCard.vue';
import expiry from '../../components/elements/expiry.vue';

export default class CloudBeds extends PaymentGatewayIntegration {
    public name = 'CloudBeds';
    public scriptUrl = null;
    public fields = {
        cvc,
        creditCard,
        expiry,
    };

    public integrationFields = {};

    public async created() {
        this.vm.loading = false;
    }

    public async serialize(additionalsGot: any) {
        const validation = this.vm.validate(true);
        if (validation.isValid) {
            return this.postSerialize(additionalsGot, {
                creditCard: this.vm.form.creditCard.value,
                brand: this.vm.form.creditCard.brand,
                cvc: this.vm.form.cvc.value,
                expiry: this.vm.form.expiry.value,
            });
        } else {
            throw validation;
        }
    }
}
